import {
  AnyDocument,
  DocsUploadFormValues,
  FormDataRequestObject,
} from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

const buildDocFormData = (data: FormDataRequestObject<any>): FormData => {
  const formData = new FormData();
  data.files.forEach(({ file, key }) => formData.append(key, file));
  if (data.json) formData.append('json', JSON.stringify(data.json));
  return formData;
};

export const postUploadApplicationDoc = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: FormDataRequestObject<DocsUploadFormValues>,
): Promise<NonPaginatedResponse<AnyDocument> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/docs/upload`,
    {
      data: buildDocFormData(data),
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.RelatedDefinitionName]: 'doc',
      },
    },
    { preventDefaultErrorToast: true },
  );
